import * as React from 'react'

const defaultSize = {
  x: 8,
  y: 6,
}

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const Expand: React.FCC<IProps> = ({ size = defaultSize, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M7 0.5L4 3.5L1 0.5"
      stroke="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
